import {NgModule} from "@angular/core";
import {NumberPipe} from "./number.pipe";
import {RemoveSpecialCharsPipe} from "./remove.special.chars.pipe";
import {EllipsisTooltipDirective} from "../../../ui/directives";

@NgModule({
declarations:[NumberPipe,RemoveSpecialCharsPipe,EllipsisTooltipDirective],
exports	:[NumberPipe,RemoveSpecialCharsPipe,EllipsisTooltipDirective],
})
export class CommonPipesModule{

}
